module.exports = __webpack_public_path__ + "media/images/new-ui-images/assigned-forms-14c17286075b4a41efd0150606d3c6be.svg";